import React from 'react';

/** English / Tamil switch. */
export const LangToggle = ({ lang, setLang, dark = false }) => (
  <div className={`inline-flex rounded-full p-0.5 text-sm print:hidden ${dark ? 'bg-white/10' : 'bg-gray-100'}`} data-testid="mypay-lang-toggle">
    {[['en', 'English'], ['ta', 'தமிழ்']].map(([k, l]) => (
      <button key={k} type="button" onClick={() => setLang(k)} data-testid={`mypay-lang-${k}`}
        className={`rounded-full px-3 py-1 transition-colors ${lang === k ? 'bg-amber-400 text-[#1A1F2E] font-semibold' : dark ? 'text-white/80 hover:text-white' : 'text-gray-600'}`}>{l}</button>
    ))}
  </div>
);

export default LangToggle;
